// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="\$ctrl.editMode ? 'Update passbook number' : 'Issue passbook'"></sub-header>

    <!-- Product information -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.product.productName}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value">{{\$ctrl.product.balance | nxCurrency}}</span>
      </div>
    </div>

    <form name="\$ctrl.transactionForm">

      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr ng-if="\$ctrl.activePassbook">
          <td></td>
          <td>Active passbook number:</td>
          <td>
            <input
              disabled
              class="value"
              type="text"
              ng-model="\$ctrl.activePassbook.number"
              />
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Passbook number:</td>
          <td>
            <input
              class="value"
              type="text"
              required
              ng-model="\$ctrl.passbook.number"
              maxlength="32"/>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          type="button"
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          type="button"
          ng-if="!\$ctrl.editMode"
          class="btn btn-success"
          ng-click="\$ctrl.issuePassbook()"
          ng-disabled="\$ctrl.transactionForm.\$invalid">
          Issue
        </button>
        <button
          type="button"
          ng-if="\$ctrl.editMode"
          class="btn btn-success"
          ng-click="\$ctrl.updatePassbookNumber()"
          ng-disabled="\$ctrl.transactionForm.\$invalid">
          Update
        </button>
      </div>

    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/common/issue-passbook/issue-passbook.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;